import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import 'emoji-picker-element';
import { EmojiClickEvent } from 'emoji-picker-element/shared';

@Component({
  selector: 'emoji-selector',
  templateUrl: 'emoji-selector.component.html',
  styleUrl: 'emoji-selector.component.scss',
  template: '<emoji-picker></emoji-picker>',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmojiSelector {
  protected readonly emojiSelected = output<string>();

  protected emojiClicked(emojiClickEvent: EmojiClickEvent): void {
    this.emojiSelected.emit(emojiClickEvent.detail.unicode ?? '⁇');
  }
}
